module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('address-form', {
    key: 1,
    ref: "residentialComponent",
    attrs: {
      "title": _vm.firstTitle,
      "parentAddress": _vm.residentialAddress,
      "states": _vm.geoLocation.states,
      "canada-states": _vm.geoLocation.canadaStates,
      "countries": _vm.geoLocation.countries,
      "validate-washington": true,
      "is-admin": _vm.isAdmin,
      "selected-user-type": _vm.selectedUserType
    }
  }), _vm._v(" "), (_vm.showPOBoxInput) ? _c('fieldset', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasBeenAllowedPOBox),
      expression: "hasBeenAllowedPOBox"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "hasBeenAllowedPOBox"
    },
    domProps: {
      "checked": Array.isArray(_vm.hasBeenAllowedPOBox) ? _vm._i(_vm.hasBeenAllowedPOBox, "") > -1 : (_vm.hasBeenAllowedPOBox)
    },
    on: {
      "click": _vm.handleAllowPOBox,
      "__c": function($event) {
        var $$a = _vm.hasBeenAllowedPOBox,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.hasBeenAllowedPOBox = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.hasBeenAllowedPOBox = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.hasBeenAllowedPOBox = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("Allow PO Box\n    ")])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "checkbox c-checkbox check-margin mb-lg"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isMailingAddressDifferent),
      expression: "isMailingAddressDifferent"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "isMailingAddressDifferent"
    },
    domProps: {
      "checked": Array.isArray(_vm.isMailingAddressDifferent) ? _vm._i(_vm.isMailingAddressDifferent, "") > -1 : (_vm.isMailingAddressDifferent)
    },
    on: {
      "click": _vm.updateMailingAddress,
      "__c": function($event) {
        var $$a = _vm.isMailingAddressDifferent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isMailingAddressDifferent = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isMailingAddressDifferent = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isMailingAddressDifferent = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("Different mailing address\n    ")])]), _vm._v(" "), _c('address-form', {
    ref: "mailingComponent",
    attrs: {
      "title": _vm.secondTitle,
      "parentAddress": _vm.mailingAddress,
      "states": _vm.geoLocation.states,
      "canada-states": _vm.geoLocation.canadaStates,
      "countries": _vm.geoLocation.countries,
      "disabled": !_vm.isMailingAddressDifferent,
      "is-admin": _vm.isAdmin,
      "selected-user-type": _vm.selectedUserType,
      "isMailing": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42309630","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Addresses.vue
// module id = 2141
// module chunks = 1